// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"47b4afab","239":"a736e1d6","455":"b884fc9a"}[chunkId] + ".chunk.js";
};